import React from "react";
import Grid from "@material-ui/core/Grid";
import { Schema } from "@comparaonline/reviews-schema";
import { ReviewCard } from "@comparaonline/ui-reviews-card";
import { useFormatMessage, useFormatDate } from "@comparaonline/react-intl-hooks";

import { MAX_CHARS_PER_COMMENT, DATE_FORMAT } from "./constants";
import { getUserAvatar } from "./helpers";

interface ReviewListProps {
  reviews: Schema.Review[];
}

export const ReviewList: React.FC<ReviewListProps> = ({ reviews }) => {
  const formatMessage = useFormatMessage();
  const formatDate = useFormatDate();
  return (
    <Grid container={true} spacing={8} direction="column">
      {reviews.map(({ id, comment, value, userName, createdAt }) => (
        <Grid item={true} key={id}>
          <ReviewCard
            username={userName || ""}
            date={formatDate(createdAt, DATE_FORMAT)}
            content={comment || ""}
            rating={value}
            avatarUrl={getUserAvatar(parseInt(id, 10))}
            collapseContentText={formatMessage("reviews.reviewCard.hide")}
            expandContentText={formatMessage("reviews.reviewCard.readMore")}
            maxContentChars={MAX_CHARS_PER_COMMENT}
          />
        </Grid>
      ))}
    </Grid>
  );
};
